import { z } from "zod";
import { SelfCertQType } from "@features/account/model/selfCertQ.model";

export const nonpaidReportCancelSchema = z.object({ result: z.boolean() });

export type GetNonpaidReportCancelType = z.infer<typeof nonpaidReportCancelSchema>;
export type ReqNonpaidReportCancelType = {
  q: SelfCertQType;
  complaintID: number;
};
